import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'

import userReducer from './features/user/userSlice'
import trackLocalSlice from './features/trackLocal/trackLocalSlice'

export function makeStore() {
  return configureStore({
    reducer: { 
      trackLocal: trackLocalSlice,
      user: userReducer
    }
  })
}

const store = makeStore()

export type AppState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AppState,
  unknown,
  Action<string>
>

export default store
